import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OrdersTable from './OrdersTable';

const ORDER_TYPES = [
  { label: 'Normal', value: 'normal' },
  { label: 'Take Profit', value: 'tp' },
  { label: 'Stop Loss', value: 'sl' },
  { label: 'Closed Orders', value: 'close_order' },
];

const OrdersPage = () => {
  const [ordersTableKey, setOrdersTableKey] = useState(0);
  const [selectedOrderType, setSelectedOrderType] = useState('normal');
  // per-tab filter modes with required defaults
  const [filters, setFilters] = useState({
    normal: 'active',
    tp: 'unfilled',
    sl: 'unfilled',
    close_order: 'filled'
  });

  // Handle orders table updates
  const handleOrdersUpdate = (orders) => {
    // This can be used to handle any additional logic when orders are updated
    // For example, updating a summary or notifications
    console.log('Orders updated:', orders.length, 'orders');
  };

  const { Title } = Typography;

  // Get heading text based on selectedOrderType
  const getHeading = () => {
    if (selectedOrderType === 'tp') return 'Take Profit Orders';
    if (selectedOrderType === 'sl') return 'Stop Loss Orders';
    if (selectedOrderType === 'close_order') return 'Closed Orders';
    return 'Normal Orders';
  };

  return (
    <div style={{ maxWidth: 1400, margin: '0 auto', padding: 24 }}>
      {/* Toast Container for notifications */}
      <ToastContainer 
        position="top-right" 
        autoClose={5000} 
        hideProgressBar={false} 
        newestOnTop 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss 
        draggable 
        pauseOnHover 
      />

      {/* Order Type Selector */}
      <div style={{
        display: 'flex',
        gap: 12,
        marginBottom: 20,
        background: '#fff',
        padding: '12px 0',
        borderRadius: 8,
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
      }}>
        {ORDER_TYPES.map(type => (
          <Button
            key={type.value}
            onClick={() => setSelectedOrderType(type.value)}
            style={{
              background: selectedOrderType === type.value ? 'black' : 'white',
              color: selectedOrderType === type.value ? 'white' : 'black',
              borderColor: 'black',
              fontWeight: 600,
              minWidth: 120,
              borderRadius: 6,
              boxShadow: selectedOrderType === type.value ? '0 2px 8px rgba(0,0,0,0.08)' : undefined
            }}
          >
            {type.label}
          </Button>
        ))}
      </div>

      {/* Table Heading + Normal filter controls (when Normal selected) - controls placed next to heading */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <Title level={3} style={{ margin: 0, textTransform: 'capitalize' }}>{getHeading()}</Title>
        {/* show controls for each tab: normal -> All/Active/Unfilled; tp/sl -> All/Unfilled; close_order -> All/Filled */}
        {(['normal','tp','sl','close_order'].includes(selectedOrderType)) && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontSize: 18, fontWeight: 700 }}>-</span>
            <div style={{ display: 'flex', gap: 8 }}>
              {/* All button (shown for all tabs) */}
              <Button
                onClick={() => setFilters(prev => ({ ...prev, [selectedOrderType]: 'all' }))}
                style={{
                  background: filters[selectedOrderType] === 'all' ? 'black' : 'white',
                  color: filters[selectedOrderType] === 'all' ? 'white' : 'black',
                  borderColor: 'black',
                  fontWeight: 600,
                  minWidth: 80,
                  borderRadius: 6
                }}
              >
                All
              </Button>

              {/* Normal tab: Active button */}
              {selectedOrderType === 'normal' && (
                <Button
                  onClick={() => setFilters(prev => ({ ...prev, normal: 'active' }))}
                  style={{
                    background: filters.normal === 'active' ? 'black' : 'white',
                    color: filters.normal === 'active' ? 'white' : 'black',
                    borderColor: 'black',
                    fontWeight: 600,
                    minWidth: 80,
                    borderRadius: 6
                  }}
                >
                  Active
                </Button>
              )}

              {/* Normal / TP / SL: Unfilled button (for TP/SL semantics differ) */}
              {(['normal','tp','sl'].includes(selectedOrderType)) && (
                <Button
                  onClick={() => setFilters(prev => ({ ...prev, [selectedOrderType]: 'unfilled' }))}
                  style={{
                    background: filters[selectedOrderType] === 'unfilled' ? 'black' : 'white',
                    color: filters[selectedOrderType] === 'unfilled' ? 'white' : 'black',
                    borderColor: 'black',
                    fontWeight: 600,
                    minWidth: 90,
                    borderRadius: 6
                  }}
                >
                  Unfilled
                </Button>
              )}

              {/* Close Orders: Filled button */}
              {selectedOrderType === 'close_order' && (
                <Button
                  onClick={() => setFilters(prev => ({ ...prev, close_order: 'filled' }))}
                  style={{
                    background: filters.close_order === 'filled' ? 'black' : 'white',
                    color: filters.close_order === 'filled' ? 'white' : 'black',
                    borderColor: 'black',
                    fontWeight: 600,
                    minWidth: 90,
                    borderRadius: 6
                  }}
                >
                  Filled
                </Button>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Orders Table */}
      <OrdersTable 
        key={ordersTableKey}
        orderType={selectedOrderType}
        onOrderUpdate={handleOrdersUpdate}
        filterMode={filters[selectedOrderType]}
      />
    </div>
  );
};

export default OrdersPage;